import {
  START, SUCCESS, COUNT_DELIVERY_PRICE, BILLING_DETAILS, DELIVERY_DETAILS, CLEAR_DELIVERY_DATA
} from "../constants";

const initialState = {
  deliveryAddress: null,
  // deliveryAddress: {
  //   "delivery_items": [
  //     {
  //       "id": 1,
  //       "amount": 23,
  //       "price": "323",
  //       "bring_in_window": true,
  //       "installation": true
  //     }
  //   ],
  //   "delivery_address": {
  //     "address_string": "Семена палия 78",
  //     "country": "Ukraine",
  //     "city": "Одесса",
  //     "street": "Семена палия 78",
  //     "house": "233",
  //     "zip": "65025",
  //     "floor": 32,
  //     "flat": null,
  //     "elevator_available": false
  //   },
  //   "delivery_to_flat": true,
  //   "express_delivery": true
  // },
  deliveryAddressErrors: null,
  deliveryData: null,
  // deliveryData: {
  //   additional_distance_price: 0,
  //   bring_through_window_price: 0,
  //   delivery_price: 2340,
  //   installation_price: 115,
  //   total_price: 2455,
  //   trucks_required: 4
  // },
  billingDetails: null,
  // billingDetails: {
  //   billing_match_customer: 'name',
  //   name: 'name',
  //   surname: 'name',
  //   phone: 'name',
  //   email: 'name@gmail.com',
  //   billing_name: 'name',
  //   billing_surname: 'surname',
  //   order_number: 312313,
  //   billing_address: {
  //     elevator_available: false,
  //     country: 'qw',
  //     city: 'wqe',
  //     zip: '2',
  //     street: 'dwad',
  //     house: '2'
  //   }
  // },
  deliveryDetails: null
  // deliveryDetails: [
  //   {
  //     "day": "2019-10-16T21:00:00.000Z",
  //     "excludeDates": [
  //       "2019-10-13T21:00:00.000Z",
  //       "2019-10-14T21:00:00.000Z",
  //       "2019-10-15T21:00:00.000Z",
  //       "2019-10-16T21:00:00.000Z",
  //       "2019-10-17T21:00:00.000Z",
  //       "2019-10-18T21:00:00.000Z",
  //       "2019-10-19T21:00:00.000Z"
  //     ],
  //     "from": "2019-10-17T10:00:00.000Z",
  //     "to": "2019-10-17T17:00:00.000Z",
  //     "excludeFrom": [
  //       "2019-10-17T09:00:00.000Z",
  //       "2019-10-17T10:00:00.000Z",
  //       "2019-10-17T11:00:00.000Z"
  //     ],
  //     "excludeTo": [
  //       "2019-10-17T16:00:00.000Z",
  //       "2019-10-17T17:00:00.000Z",
  //       "2019-10-17T18:00:00.000Z"
  //     ]
  //   },
  //   {
  //     "day": "2019-10-23T21:00:00.000Z",
  //     "excludeDates": [
  //       "2019-10-20T21:00:00.000Z",
  //       "2019-10-21T21:00:00.000Z",
  //       "2019-10-22T21:00:00.000Z",
  //       "2019-10-23T21:00:00.000Z",
  //       "2019-10-24T21:00:00.000Z",
  //       "2019-10-25T21:00:00.000Z",
  //       "2019-10-26T21:00:00.000Z"
  //     ],
  //     "from": "2019-10-24T12:00:00.000Z",
  //     "to": "2019-10-24T17:00:00.000Z",
  //     "excludeFrom": [
  //       "2019-10-24T11:00:00.000Z",
  //       "2019-10-24T12:00:00.000Z",
  //       "2019-10-24T13:00:00.000Z"
  //     ],
  //     "excludeTo": [
  //       "2019-10-24T16:00:00.000Z",
  //       "2019-10-24T17:00:00.000Z",
  //       "2019-10-24T18:00:00.000Z"
  //     ]
  //   },
  //   {
  //     "day": "2019-10-29T22:00:00.000Z",
  //     "excludeDates": [
  //       "2019-10-26T21:00:00.000Z",
  //       "2019-10-27T22:00:00.000Z",
  //       "2019-10-28T22:00:00.000Z",
  //       "2019-10-29T22:00:00.000Z",
  //       "2019-10-30T22:00:00.000Z",
  //       "2019-10-31T22:00:00.000Z",
  //       "2019-11-01T22:00:00.000Z"
  //     ],
  //     "from": "2019-10-30T12:00:00.000Z",
  //     "to": "2019-10-30T17:00:00.000Z",
  //     "excludeFrom": [
  //       "2019-10-30T11:00:00.000Z",
  //       "2019-10-30T12:00:00.000Z",
  //       "2019-10-30T13:00:00.000Z"
  //     ],
  //     "excludeTo": [
  //       "2019-10-30T16:00:00.000Z",
  //       "2019-10-30T17:00:00.000Z",
  //       "2019-10-30T18:00:00.000Z"
  //     ]
  //   }
  // ]
};

export default (state = initialState, action) => {
  const {type, payload, response} = action;

  switch (type) {
    case COUNT_DELIVERY_PRICE + START:
      return { ...state, deliveryData: null, deliveryAddress: null, deliveryAddressErrors: null };

    case COUNT_DELIVERY_PRICE + SUCCESS:
      return { ...state, deliveryData: !Array.isArray(response) ? {...response} : null, deliveryAddress:  {...payload}, deliveryAddressErrors: Array.isArray(response) ? [...response] : [] };

    case BILLING_DETAILS:
      return { ...state, billingDetails: {...payload.data} };

    case DELIVERY_DETAILS:
      return { ...state, deliveryDetails: [...payload.dataDetails] };

    case CLEAR_DELIVERY_DATA:
      return { ...state, deliveryAddress: null, deliveryAddressErrors: null, deliveryData: null, billingDetails: null, deliveryDetails: null };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/delivery.js